var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.error)?_c('div',{staticClass:"form-field__error"},[_c('common-icon',{attrs:{"name":"forbidden","size":"medium"}}),_c('p',[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.error))]})],2)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }